import { ModuleCodes } from '../../../../models/modules';
import { WebSocketsReservationEvents, WebSocketsTripEvents } from '../../../../models/web-sockets';

const mServerTable = {
  footer: {
    selectAll: 'Alles auswählen',
    allPageSelected: {
      text: 'Alle {{number}} Elemente auf dieser Seite sind ausgewählt.',
      action: 'Alle {{number}} Elemente auswählen',
    },
    allPagesSelected: {
      text: 'Alle {{number}} Elemente in der Tabelle sind ausgewählt.',
      action: 'Auswahl löschen',
    },
  },
  noResults: 'Keine Ergebnisse',
  total: 'Gesamt',
  generalSearch: 'Suchen',
  actions: {
    more: 'Mehr',
    clearFilters: 'Filter löschen',
    hiddenColumns: 'Ausgeblendete Spalten',
    refreshTable: 'Tabelle aktualisieren',
  },
  floatingActions: {
    extraActionsMenu: {
      button: 'Mehr',
      title: 'Weitere Aktionen',
    },
    selectedText: {
      single: 'Ausgewähltes Element',
      many: 'Ausgewählte Elemente',
    },
  },
  updates: {
    [ModuleCodes.Trips]: {
      [WebSocketsTripEvents.New]: 'Neu',
      [WebSocketsTripEvents.Update]: 'Aktualisieren',
      [WebSocketsTripEvents.Cancel]: 'Stornierung',
      [WebSocketsTripEvents.StatusChange]: 'Statusänderung',
    },
    [ModuleCodes.Reservations]: {
      [WebSocketsReservationEvents.New]: 'Neu',
      [WebSocketsReservationEvents.Update]: 'Aktualisieren',
      [WebSocketsReservationEvents.Cancel]: 'Stornierung',
      [WebSocketsReservationEvents.StatusChange]: 'Statusänderung',
    },
  },
};

export default mServerTable;
